import { toast } from "react-toastify";
import { requestBackendReportExport } from "./backendReportExport";

export const AD_GROUP_REPORT_TYPE = "AD_GROUP_REPORT";
const AD_GROUP_CUBE = "client_daily_adset_amazon";

const CUBE_MEASURE_TO_API = {
  cost: "spends",
  costDRR: "spends_drr",
  impressions: "impressions",
  impressionsDRR: "impressions_drr",
  clicks: "clicks",
  clicksDRR: "clicks_drr",
  ctr: "ctr",
  ctrDRR: "ctr_drr",
  cpc: "cpc",
  cpcDRR: "cpc_drr",
  cpm: "cpm",
  cpmDRR: "cpm_drr",
  conversions14d: "orders",
  conversions14dDRR: "orders_drr",
  conversion_rate: "cvr",
  conversion_rateDRR: "cvr_drr",
  sales14d: "revenue",
  sales14dDRR: "revenue_drr",
  average_order_value: "aov",
  average_order_valueDRR: "aov_drr",
  acos: "acos",
  acosDRR: "acos_drr",
  roas: "roas",
  roasDRR: "roas_drr",
};

const CUBE_DIMENSION_TO_API = {
  adGroupNameDimension: "ad_group_name",
  adGroupIdDimension: "ad_group_id",
  campaignNameDimension: "campaign_name",
  campaignIdDimension: "campaign_id",
  portfolioNameDimension: "portfolio_name",
  portfolioIdDimension: "portfolio_id",
  campaignTypeDimension: "campaign_type",
  targetingTypeDimension: "targeting_type",
  productSetDimension: "product_set",
  campaignFormatDimension: "campaign_format",
  campaignStatusDimension: "campaign_status",
  adgroupStatusDimension: "adgroup_status",
  weekDimension: "week",
  monthDimension: "month",
  obDate: "date",
};

function stripTablePrefix(value = "") {
  return value.replace(`${AD_GROUP_CUBE}.`, "");
}

function cubeMeasureToApi(measureKey) {
  return CUBE_MEASURE_TO_API[measureKey] ?? measureKey;
}

function cubeDimensionToApi(dimensionKey) {
  return CUBE_DIMENSION_TO_API[dimensionKey] ?? dimensionKey;
}

function normalizeCubeQueryOrder(cubeQueryOrder = {}) {
  if (Array.isArray(cubeQueryOrder)) {
    return Object.fromEntries(cubeQueryOrder);
  }
  return cubeQueryOrder;
}

export function getAdGroupReportVisibleColumnKeys({
  cubeQueryMeasures = [],
  cubeQueryDimensions = [],
}) {
  const dimensionKeys = cubeQueryDimensions.map((dimension) =>
    cubeDimensionToApi(stripTablePrefix(dimension))
  );
  const measureKeys = cubeQueryMeasures.map((measure) =>
    cubeMeasureToApi(stripTablePrefix(measure))
  );

  return [...dimensionKeys, ...measureKeys].filter(Boolean);
}

export function buildAdGroupReportExportQueryBody({
  cubeQueryMeasures = [],
  cubeQueryDimensions = [],
  cubeQueryOrder = {},
  cubeQueryFilters = [],
  cubeQueryTimeDimensions = [],
}) {
  const timeDimensions = cubeQueryTimeDimensions.map((timeDimension) => {
    const formatted = { dimension: timeDimension.dimension };

    if (timeDimension.compareDateRange) {
      formatted.compareDateRange = timeDimension.compareDateRange;
    } else if (timeDimension.dateRange) {
      formatted.dateRange = timeDimension.dateRange;
    }

    return formatted;
  });

  return {
    cube_query: {
      measures: cubeQueryMeasures,
      dimensions: cubeQueryDimensions,
      filters: cubeQueryFilters,
      timeDimensions,
      order: normalizeCubeQueryOrder(cubeQueryOrder),
      limit: 5000,
    },
  };
}

export async function exportAdGroupReport({
  clientId,
  userPlatform = "amazon",
  triggeredBy,
  totalCount,
  queryBody,
  visibleColumnKeys,
  isComparison = false,
  setIsExporting = () => {},
  onExportSuccess = () => {},
}) {
  try {
    setIsExporting(true);

    await requestBackendReportExport({
      clientId,
      userPlatform,
      reportType: AD_GROUP_REPORT_TYPE,
      totalCount,
      triggeredBy,
      queryBody,
      frontendConfig: {
        include_summary_row: true,
        is_comparison: isComparison,
        columns: visibleColumnKeys,
      },
    });

    onExportSuccess();
  } catch (error) {
    console.error(error);
    toast.error(
      error?.response?.data?.message ?? "Failed to submit export request."
    );
  } finally {
    setIsExporting(false);
  }
}
